import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/containers/providers/ClientProviders/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/containers/RootLayout/ClientExternalScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/containers/RootLayout/GoogleTagManager.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/styles/HideChatWidget.tsx");
